import { ArrowRight, Check, Clock, ClipboardList, Layers } from "lucide-react";
import { Reveal, SectionHead } from "./Section";

const STEPS = [
  { level: "Basic", icon: Clock, title: "Payroll timesheets", line: "Your crew clocks on and off from their phone. You approve and pay.",
    items: ["Clock on / off with breaks", "Weekly or fortnightly pay periods", "Payroll PDF for your bookkeeper", "Rosters and leave requests"] },
  { level: "Growing", icon: ClipboardList, title: "Jobs, clients & proof", line: "Tick on jobs and your client list when you need them.",
    items: ["Jobs with site photos and notes", "Branded job reports for clients", "Your client list in one place"] },
  { level: "Full", icon: Layers, title: "Everything, your way", line: "The whole business running from one place.",
    items: ["Client invoices paid by card or bank", "Chase overdue and send statements", "Multiple depots and your branding", "Changes built just for your company"] },
];
const LIFT = ["lg:mt-40", "lg:mt-20", "lg:mt-0"];

const Step = ({ s, i }) => (
  <Reveal delay={0.12 * i} className={LIFT[i]}>
    <div className={`relative h-full rounded-2xl p-6 sm:p-7 border transition-[transform,border-color] duration-300 hover:-translate-y-1 ${i === 2 ? "bg-white text-[#0F172A] border-white" : "bg-white/[0.04] border-white/10 hover:border-[#EA580C]/60"}`} data-testid={`home-ladder-step-${i + 1}`}>
      <div className="flex gap-1.5" aria-hidden>{[0, 1, 2].map((k) => <span key={k} className={`h-1.5 flex-1 rounded-full ${k <= i ? "bg-[#EA580C]" : i === 2 ? "bg-slate-200" : "bg-white/10"}`} />)}</div>
      <div className="mt-6 flex items-center justify-between">
        <span className={`w-11 h-11 rounded-xl grid place-items-center ${i === 2 ? "bg-[#FFEDD5] text-[#9A3412]" : "bg-white/10 text-[#FDBA74]"}`}><s.icon className="w-5 h-5" /></span>
        <span className={`font-mono text-[11px] font-semibold tracking-[0.2em] uppercase ${i === 2 ? "text-[#9A3412]" : "text-[#EA580C]"}`}>Step {i + 1} · {s.level}</span>
      </div>
      <h3 className="font-display mt-5 text-2xl font-extrabold tracking-tight">{s.title}</h3>
      <p className={`mt-2 text-sm ${i === 2 ? "text-slate-600" : "text-slate-400"}`}>{s.line}</p>
      {i > 0 && <p className={`mt-5 text-xs font-semibold ${i === 2 ? "text-[#9A3412]" : "text-[#FDBA74]"}`}>+ everything in {STEPS[i - 1].level}</p>}
      <ul className={`${i > 0 ? "mt-2" : "mt-5"} space-y-2.5 text-sm`}>
        {s.items.map((t) => <li key={t} className="flex gap-2.5"><Check className="w-4 h-4 mt-0.5 shrink-0 text-[#EA580C]" />{t}</li>)}
      </ul>
    </div>
  </Reveal>
);

export const GrowLadder = ({ onStart }) => (
  <section id="ladder" className="scroll-mt-16 relative bg-[#0B1120] text-white py-24 lg:py-32 overflow-hidden home-noise" data-testid="home-ladder">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead dark num="03" eyebrow="Start simple, add more" title="As basic or as full on as you need."
        sub="Cross Jobs can be as basic as a payroll timesheet system, or as full on with everything included. Built and customisable to suit your business needs." />
      <div className="mt-14 grid md:grid-cols-3 gap-5 lg:gap-6 items-start">
        {STEPS.map((s, i) => <Step key={s.level} s={s} i={i} />)}
      </div>
      <Reveal delay={0.2} className="mt-12 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8 border-t border-white/10 pt-10">
        <div>
          <p className="font-display text-xl sm:text-2xl font-bold" data-testid="home-ladder-help">Let us know how we can help you.</p>
          <p className="mt-1 text-sm text-slate-400">Every plan includes every step. Tick features on or off in Settings as you go.</p>
        </div>
        <button onClick={onStart} className="group sm:ml-auto inline-flex items-center gap-2 rounded-full bg-[#EA580C] hover:bg-[#C2410C] px-7 py-3.5 font-bold transition-colors" data-testid="home-ladder-signup-btn">
          Sign up and get started <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
